import React, { useEffect, useState, useContext, useMemo } from "react";
import { stores } from "../../data/stores";
import { threeNearestStores } from "./utilsFunction";
import LeadFormAppointmentComponent from "./LeadFormAppointmentComponent";
import { TimeFormValues } from "./LeadFormComponentConfig";
interface LeadFormStoreInfoProps {
  coords: { lat: number; lng: number };
  onNextStep: (data: TimeFormValues) => void;
}
const LeadFormStoreInfoComponent = ({
  coords,
  onNextStep,
}: LeadFormStoreInfoProps) => {
  const [selectedStore, setSelectedStore] = useState<any>(null);
  const [chooseStore, setChooseStore] = useState<boolean>(false);
  const [threeStores, setThreeStores] = useState<any[]>([]);

  useEffect(() => {
    if (stores.length > 0) {
      const sortedStores = threeNearestStores(stores, coords);
      setThreeStores(sortedStores);
      setSelectedStore(sortedStores[0] || null);
    }
  }, [coords]);

  const handleSelectStore = (store: any) => {
    setSelectedStore(store);
  };
  const getTime = (time: Date) => {
    onNextStep({
      Time: time,
      StoreLocation: selectedStore,
    });
  };
  if (!stores.length) {
    return <p>Loading stores...</p>;
  }

  // if (chooseStore) {
  //   return (
  //     <LeadFormChangeDisplayStore
  //       threeStores={threeStores}
  //       handleSelectStore={handleSelectStore}
  //       selectedStore={selectedStore}
  //       closeChooseStore={() => setChooseStore(false)}
  //       chooseStore={() => setChooseStore(true)}
  //     />
  //   );
  // }
  return (
    <LeadFormAppointmentComponent
      selectedStore={selectedStore}
      chooseStore={() => setChooseStore(true)}
      getTime={getTime}
      threeStores={threeStores}
      handleSelectStore={handleSelectStore}
    />
  );
};

export default LeadFormStoreInfoComponent;
